import { createApiSlice } from "@common";
import {
  CRUD_ASSET_TYPE,
  GET_ASSET_TYPE
} from "@routes";

// Define the API config array
const apiConfig = [
  {
    name: "addAssetType",
    method: "post",
    url: CRUD_ASSET_TYPE,
    stateKey: "message",
  },
  {
    name: "getAssetType",
    method: "get",
    url: GET_ASSET_TYPE,
    stateKey: "data",
  },
  {
    name: "updateAssetType",
    method: "put",
    url: CRUD_ASSET_TYPE,
    stateKey: "message",
  },
  {
    name: "updateStatusAssetType",
    method: "patch",
    url: CRUD_ASSET_TYPE,
    stateKey: "message",
  },
  {
    name: "deleteAssetType",
    method: "delete",
    url: CRUD_ASSET_TYPE,
    stateKey: "message",
  },
];

// Define custom reducers and their initial state
const customReducers = {
  initialState: {
    additionalData: [],
    selectedData: {},
  },
  reducers: {
    setAdditionalData: (state, action) => {
      state.additionalData = action.payload;
    },
  },
  extraReducers: {
    // Example of custom extra reducer
    someCustomAction: (state, action) => {
      // Custom reducer logic
    },
  },
};

// Generate the slice, thunks, and actions using the utility function
const { slice, thunks, actions } = createApiSlice(
  "assetType",
  apiConfig,
  customReducers,
);
const assetTypeSlice = slice;
// Export the slice's reducer
export default assetTypeSlice.reducer;


// Destructure and export thunks directly from thunksExports
export const {
  addAssetType,
  getAssetType,
  updateAssetType,
  deleteAssetType,
  updateStatusAssetType
} = thunks;

// Destructure and export actions
export const { rowSelect, } = actions;
